import styled from '@emotion/styled';
import { Flex } from 'antd';

export const Wrapper = styled(Flex)`
  width: 100%;

  .access-map-row {
    cursor: pointer;
  }
`;

export const Header = styled(Flex)`
  width: 100%;
`;

export const Title = styled.span`
  font-size: 24px;
  font-weight: 600;
  line-height: 32px;
  color: ${({ theme }) => theme.colors.black};
`;

export const Subtitle = styled.span`
  font-size: 13px;
  line-height: 20px;
  color: ${({ theme }) => theme.colors.grayDark};
`;
